"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;

var _react = _interopRequireWildcard(require("react"));

require("react-datepicker/dist/react-datepicker.css");

var _format = _interopRequireDefault(require("date-fns/format"));

var _compareAsc = _interopRequireDefault(require("date-fns/compareAsc"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _constants = require("../../constants");

var _state = require("./state");

var _useFetchIndication2 = require("../../hooks/useFetchIndication");

var _DurationTrip = require("@lt/components/components/DurationTrip/DurationTrip");

var _DatePickerTabs = _interopRequireDefault(require("./components/DatePickerTabs"));

var _utils = require("./utils");

var _reactDom = require("react-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatePicker = function DatePicker(_ref) {
  var onChange = _ref.onChange,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$isWizard = _ref.isWizard,
      isWizard = _ref$isWizard === void 0 ? false : _ref$isWizard,
      _ref$isWhiteLabel = _ref.isWhiteLabel,
      isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel,
      initialValue = _ref.initialValue,
      open = _ref.open,
      onClose = _ref.onClose,
      searchType = _ref.searchType,
      className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      searchCalendarDuration = _ref.searchCalendarDuration,
      onPanelChange = _ref.onPanelChange,
      departureId = _ref.departureId,
      placeId = _ref.placeId,
      _ref$isOpenInitial = _ref.isOpenInitial,
      isOpenInitial = _ref$isOpenInitial === void 0 ? false : _ref$isOpenInitial,
      setBodyLocked = _ref.setBodyLocked;

  var initial = _objectSpread(_objectSpread({}, _state.initialState), initialValue || {});

  var _useReducer = (0, _react.useReducer)(_state.reducer, initial),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var left = state.left,
      right = state.right,
      shift = state.shift,
      _state$inputFocuses = state.inputFocuses,
      inputFocuses = _state$inputFocuses === void 0 ? {
    isStartDateFocus: false,
    isEndDateFocus: false
  } : _state$inputFocuses,
      initialTab = state.initialTab,
      buttonsClicked = state.buttonsClicked;
  var startDate = left.date;
  var endDate = right.date;
  var isStartDateFocus = inputFocuses.isStartDateFocus,
      isEndDateFocus = inputFocuses.isEndDateFocus;
  var isHotelVariant = variant === 'hotel';
  (0, _react.useEffect)(function () {
    if ((isWizard || isOpenInitial) && !isStartDateFocus && !isEndDateFocus) {
      dispatch((0, _state.setStartDateFocus)());
    }
  }, [isWizard, isOpenInitial, state]);
  (0, _react.useEffect)(function () {
    if (onPanelChange) {
      onPanelChange({
        left: startDate,
        right: endDate
      });
    }
  }, [startDate, endDate]);

  var handleChangeValue = function handleChangeValue(changes) {
    if (!onChange) return;
    onChange(_objectSpread({
      left: left,
      right: right,
      inputFocuses: inputFocuses,
      shift: shift,
      initialTab: initialTab,
      buttonsClicked: buttonsClicked
    }, changes));
  };

  var openCalendar = function openCalendar() {
    if (!isWizard) {
      setOpen(true);
    }

    setBodyLocked === null || setBodyLocked === void 0 ? void 0 : setBodyLocked(true);
  };

  var closeCalendar = function closeCalendar(event) {
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
    setBodyLocked === null || setBodyLocked === void 0 ? void 0 : setBodyLocked(false);
    onClose();
  };

  var handleClickStartInput = function handleClickStartInput() {
    dispatch((0, _state.setStartDateFocus)());
    openCalendar();
  };

  var handleClickEndInput = function handleClickEndInput() {
    dispatch((0, _state.setEndDateFocus)());
    openCalendar();
  };

  var handleEndDateClear = function handleEndDateClear() {
    handleChangeValue({
      right: {
        date: null
      }
    });
    dispatch((0, _state.changeDates)({
      startDate: startDate,
      endDate: null
    }));
  };

  var handleButtonClick = function handleButtonClick(buttonName) {
    dispatch((0, _state.trackButtonClick)(buttonName));
  };

  var handleStartDateClear = function handleStartDateClear(event) {
    handleChangeValue({
      left: {
        date: null
      },
      right: {
        date: null
      }
    });
    dispatch((0, _state.changeDates)({
      startDate: null,
      endDate: null
    })); // Хак на закрытие календаря, чтобы корректно отображались первые месяцы после сброса

    closeCalendar(event);
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      localOpen = _useState2[0],
      setOpen = _useState2[1];

  var minDate = (0, _utils.calcMinDate)(searchType);
  (0, _react.useEffect)(function () {
    setOpen(!!open);

    if (open) {
      dispatch((0, _state.setStartDateFocus)());
    }
  }, [open]);
  (0, _react.useEffect)(function () {
    dispatch((0, _state.updateDatepickerState)(initial));
  }, [initialValue]);

  var changeShift = function changeShift(shift) {
    return dispatch((0, _state.changeShiftAction)(shift));
  };

  var onChangeCalendar = function onChangeCalendar(date) {
    var start = isStartDateFocus ? date : startDate;
    var end = isEndDateFocus ? date : endDate;
    var isReset = start && end && (0, _compareAsc["default"])(new Date(start), new Date(end)) > 0;
    var saveStart = isReset ? date : start;
    var saveEnd = isReset ? null : end;
    var abortCondition = saveStart && saveEnd && (0, _format["default"])(new Date(saveStart), 'ddMMyy') === (0, _format["default"])(new Date(saveEnd), 'ddMMyy');
    if (abortCondition) return;

    if (!isReset && isStartDateFocus) {
      dispatch((0, _state.setEndDateFocus)());
      dispatch((0, _state.changeDates)({
        startDate: saveStart,
        endDate: null
      }));
    }

    if (!isReset && isEndDateFocus) {
      dispatch((0, _state.setStartDateFocus)());
      dispatch((0, _state.changeDates)({
        startDate: saveStart,
        endDate: saveEnd
      }));
    }

    if (isReset) {
      dispatch((0, _state.setEndDateFocus)());
      dispatch((0, _state.changeDates)({
        startDate: saveStart,
        endDate: null
      }));
    }
  };

  var closeCalendarHandler = function closeCalendarHandler(event) {
    applyButtonHandler(event);
  };

  var applyButtonHandler = function applyButtonHandler(event) {
    closeCalendar(event);

    if (startDate && endDate) {
      handleChangeValue();
    }
  };

  var _useFetchIndication = (0, _useFetchIndication2.useFetchIndication)({
    isMobile: Boolean(isMobile),
    isHotelVariant: isHotelVariant,
    searchType: searchType,
    departureId: departureId,
    placeId: placeId,
    calendarOpened: localOpen,
    startDate: startDate
  }),
      indicationMap = _useFetchIndication.indicationMap,
      directFlightsInfo = _useFetchIndication.directFlightsInfo,
      setStartCurrentMonth = _useFetchIndication.setStartCurrentMonth;

  var datePickerTabsComponent = /*#__PURE__*/_react["default"].createElement(_DatePickerTabs["default"], {
    isHotelVariant: isHotelVariant,
    open: localOpen,
    closeCalendar: closeCalendarHandler,
    leftValue: left,
    rightValue: right,
    onChangeCalendar: onChangeCalendar,
    onButtonClick: handleButtonClick,
    currentShift: shift,
    onChangeShift: changeShift,
    searchCalendarDuration: searchCalendarDuration,
    applyButtonHandler: applyButtonHandler,
    minDate: minDate,
    isMobile: isMobile,
    isWizard: isWizard,
    isWhiteLabel: isWhiteLabel,
    isEndDateFocus: isEndDateFocus,
    isHotelOnly: searchType === _constants.SEARCH_TYPE_NAMES.HOTEL,
    indicationMap: indicationMap,
    directFlightsInfo: directFlightsInfo,
    setStartCurrentMonth: setStartCurrentMonth
  });

  return /*#__PURE__*/_react["default"].createElement(DatePickerContainer, {
    $isMobile: isMobile,
    $isWizard: isWizard,
    className: className
  }, localOpen && isMobile && !isWizard ? /*#__PURE__*/_react["default"].createElement(OverflowRestrictor, null) : null, /*#__PURE__*/_react["default"].createElement(_DurationTrip.DurationTrip, {
    leftValue: left,
    rightValue: right,
    shift: shift,
    openCalendar: openCalendar,
    isMobile: isMobile,
    isWizard: isWizard,
    searchType: searchType,
    isOpenCalendar: localOpen,
    onStartDateClick: handleClickStartInput,
    onEndDateClick: handleClickEndInput,
    onStartDateClear: handleStartDateClear,
    onEndDateClear: handleEndDateClear,
    isStartDateFocus: isStartDateFocus,
    isEndDateFocus: isEndDateFocus,
    variant: variant,
    isWhiteLabel: isWhiteLabel
  }), isMobile && !isWizard ? /*#__PURE__*/(0, _reactDom.createPortal)(datePickerTabsComponent, document.body) : datePickerTabsComponent);
};

exports.DatePicker = DatePicker;

var DatePickerContainer = _styledComponents["default"].div.withConfig({
  displayName: "DatePicker__DatePickerContainer",
  componentId: "sc-b8yvvo-0"
})(["display:flex;flex-direction:column;order:0;", " ", " font-family:inherit !important;"], function (_ref2) {
  var $isWizard = _ref2.$isWizard;
  return !$isWizard && "\n    width: 100%;\n    height: 100%;\n  ";
}, function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["overflow:hidden;order:1;align-items:center;"]);
});

var OverflowRestrictor = (0, _styledComponents.createGlobalStyle)(["body{overflow:hidden;}"]);